import { ALL_PACKAGES_GET, ALL_PACKAGES_GET_ERROR, ALL_PACKAGES_GET_SUCCESS, CHECKUP_PAYMENTS, CHECKUP_PAYMENTS_ERROR, CHECKUP_PAYMENTS_SUCCESS, CHECKUPS_HEALTH_RECORD_REQUEST, CHECKUPS_HEALTH_RECORD_REQUEST_ERROR, CHECKUPS_HEALTH_RECORD_REQUEST_SUCCESS, MY_CHECKUPS_GET, MY_CHECKUPS_GET_ERROR, MY_CHECKUPS_GET_SUCCESS, PACKAGE_DETAILS_ID, PROMTION_PACKAGES_GET, PROMTION_PACKAGES_GET_ERROR, PROMTION_PACKAGES_GET_SUCCESS, SELECTED_CHECKUP_TABLE } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const checkupsReducer = (state = initialState, action) => {
    switch (action.type) {
    case MY_CHECKUPS_GET:        
        return { ...state, loading: true, successMsg : null };
    case MY_CHECKUPS_GET_SUCCESS :                
        return { ...state, checkupList : action.payload, loading: false };
    case MY_CHECKUPS_GET_ERROR :
        return { ...state,loading: false };
    case SELECTED_CHECKUP_TABLE :
        return { ...state, selectedData : action.payload };
    case CHECKUPS_HEALTH_RECORD_REQUEST:        
        return { ...state, loading: true };
    case CHECKUPS_HEALTH_RECORD_REQUEST_SUCCESS :                
        return { ...state, healthRecords : action.payload, loading: false };
    case CHECKUPS_HEALTH_RECORD_REQUEST_ERROR :
        return { ...state,loading: false };
    case ALL_PACKAGES_GET:        
        return { ...state, successMsg : null, loading: true };
    case ALL_PACKAGES_GET_SUCCESS :                
        return { ...state, packageList : action.payload, loading: false };
    case ALL_PACKAGES_GET_ERROR :
        return { ...state,loading: false };
    case PACKAGE_DETAILS_ID :
        return {...state, packageId : action.packageId };
    case CHECKUP_PAYMENTS:        
        return { ...state, loading: true };
    case CHECKUP_PAYMENTS_SUCCESS :                
        return { ...state, successMsg : action.successMsg, loading: false };
    case CHECKUP_PAYMENTS_ERROR :
        return { ...state,loading: false };
    case PROMTION_PACKAGES_GET:        
        return { ...state, loading: false };
    case PROMTION_PACKAGES_GET_SUCCESS :                
        return { ...state, packagaePromotions : action.payload, loading: false };
    case PROMTION_PACKAGES_GET_ERROR :
        return { ...state,loading: false };
    default:
        return state;
    }
};
  